import { z } from 'zod';

export const statusEnum = z.enum(['active', 'inactive']);

export const notificationPreferencesSchema = z.object({
  'opt-ins': z.array(
    z.object({
      level: z.coerce.string(),
      preferences: z.array(
        z.object({
          channel: z.coerce.string(),
          contact: z.coerce.string(),
          status: statusEnum,
        }),
      ),
    }),
  ),
});

export type NotificationPreferences = z.infer<
  typeof notificationPreferencesSchema
>;
export type NotificationPreferencesOptInStatusEnum = z.infer<typeof statusEnum>;
